import { Text } from "basis";
import { useFaqData } from "./useFaqData";

function Question({ title, productType, region, children }) {
  const { data } = useFaqData();
  const {
    isLoggedIn,
    hasCreditCards,
    hasPersonalLoans,
    hasAUaccounts,
    hasNZaccounts,
  } = data;

  if (
    isLoggedIn &&
    ((productType === "credit-card" && hasCreditCards === false) ||
      (productType === "personal-loan" && hasPersonalLoans === false) ||
      (region === "AU" && hasAUaccounts === false) ||
      (region === "NZ" && hasNZaccounts === false))
  ) {
    return null;
  }

  return (
    <>
      <Text margin="0 0 1 0">
        <strong>{title}</strong>
      </Text>
      {children}
    </>
  );
}

export { Question };
